import React from "react";
import EditIcon from "@/assets/icon/edit.svg";
import {
  getGender,
  isData,
  maskPan,
  splitDate,
} from "@/utility/helperFunctions";
import { useSelector } from "react-redux";

const BasicDetails = ({ data, onProfileUpdate }) => {
  const isEnabledMobileModification = useSelector((state:any) => state.featureflag?.hyperverge?.modification?.phone?.isEnabled)
  const isEnabledEmailModification = useSelector((state:any) => state.featureflag?.hyperverge?.modification?.email?.isEnabled)

  return (
    <div>
      <div className="tw-mt-4">
        <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
          Full Name
        </div>
        <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed tw-capitalize">
          { 
            data.userFullName
          }
        </div>
      </div>
      <div className="tw-mt-4 tw-flex tw-items-end">
        <div className="tw-flex-1">
          <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
            Mobile Number
          </div>
          <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed">
            {isData(data?.phone)}
          </div>
        </div>
        {isEnabledMobileModification &&
        <div className="tw-flex-1">
          <button onClick={() => onProfileUpdate("phoneUpdate")} className="tw-flex tw-w-fit tw-gap-[2px] tw-cursor-pointer">
            <div>
              <img alt="" src={EditIcon} />
            </div>
            <div className="tw-text-[12px] tw-text-primaryBlack tw-font-nmmed tw-pt-[1px]">
              Edit
            </div>
          </button>
        </div>
        }
      </div>
      <div className="tw-mt-4 tw-flex tw-items-end">
        <div className="tw-flex-1">
          <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
            Email Address
          </div>
          <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed tw-lowercase">
            {isData(data?.email)}
          </div>
        </div>
        {isEnabledEmailModification &&
        <div className="tw-flex-1">
          <div onClick={() => onProfileUpdate("emailUpdate")} className="tw-flex tw-w-fit tw-gap-[2px] tw-cursor-pointer">
            <div>
              <img alt="" src={EditIcon} />
            </div>
            <div className="tw-text-[12px] tw-text-primaryBlack tw-font-nmmed tw-pt-[1px]">
              Edit
            </div>
          </div>
        </div>
        }
      </div>
      <div className="tw-mt-4 tw-flex tw-items-end">
        <div className="tw-flex-1">
          <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
            PAN Number
          </div>
          <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed tw-uppercase">
            {maskPan(data?.panNumber, [4, -1])}
          </div>
        </div>
        <div className="tw-flex-1">
          <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
            DOB
          </div>
          <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed">
            {
              splitDate(
                data?.dobAsDigilockerPan ||
                  data?.dobAsDigilockerAadhaar
              ).date
            }
          </div>
        </div>
      </div>
      <div className="tw-mt-4 tw-flex tw-items-end">
        <div className="tw-flex-1">
          <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
            Gender
          </div>
          <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed">
            {getGender(
              data?.genderAsDigilockerPan ||
                data?.genderAsDigilockerAadhaar
            )}
          </div>
        </div>
        <div className="tw-flex-1">
          <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
            Marital Status
          </div>
          <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed">
            {isData(data?.maritalStatus)}
          </div>
        </div>
      </div>
      <div className="tw-mt-4">
        <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
          Address
        </div>
        <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed">
          {isData(
            data?.correspondenceAddress ||
              data?.permanentAddress ||
              data?.currentAddressAsDigilockerAadhaar ||
              data?.permanentAddressAsDigilockerAadhaar
          )}
        </div>
      </div>
    </div>
  );
};

export default BasicDetails;
